import { fetchBasicJsonPost, fetchBasicJsonPostJson } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        return fetchBasicJsonPostJson(
            '/Speciality/GetDataTableData',
            { data: Object.assign(filter, parameters), signal: signal },
            { useBlock: !signal }
        );
    },
    create: name => {
        return fetchBasicJsonPost('/Speciality/Create', {
            data: { name: name }
        });
    },
    delete: id => {
        return fetchBasicJsonPost('/Speciality/Remove', {
            data: { id: id }
        });
    }
};
